// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetUserSessionsChatSessionsGetQueryResponse,
  GetUserSessionsChatSessionsGetQueryParams,
  GetUserSessionsChatSessionsGet422,
} from "../models/chatController/GetUserSessionsChatSessionsGet.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type {
  QueryKey,
  QueryClient,
  UseQueryOptions,
  UseQueryReturnType,
} from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { getUserSessionsChatSessionsGet } from "../client/getUserSessionsChatSessionsGet.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const getUserSessionsChatSessionsGetQueryKey = (
  params?: MaybeRefOrGetter<GetUserSessionsChatSessionsGetQueryParams>,
) => [{ url: "/chat/sessions" }, ...(params ? [params] : [])] as const;

export type GetUserSessionsChatSessionsGetQueryKey = ReturnType<
  typeof getUserSessionsChatSessionsGetQueryKey
>;

export function getUserSessionsChatSessionsGetQueryOptions(
  params?: MaybeRefOrGetter<GetUserSessionsChatSessionsGetQueryParams>,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getUserSessionsChatSessionsGetQueryKey(params);
  return queryOptions<
    GetUserSessionsChatSessionsGetQueryResponse,
    ResponseErrorConfig<GetUserSessionsChatSessionsGet422>,
    GetUserSessionsChatSessionsGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getUserSessionsChatSessionsGet(toValue(params), {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Get user's chat sessions
 * @summary Get User Sessions
 * {@link /chat/sessions}
 */
export function useGetUserSessionsChatSessionsGet<
  TData = GetUserSessionsChatSessionsGetQueryResponse,
  TQueryData = GetUserSessionsChatSessionsGetQueryResponse,
  TQueryKey extends QueryKey = GetUserSessionsChatSessionsGetQueryKey,
>(
  params?: MaybeRefOrGetter<GetUserSessionsChatSessionsGetQueryParams>,
  options: {
    query?: Partial<
      UseQueryOptions<
        GetUserSessionsChatSessionsGetQueryResponse,
        ResponseErrorConfig<GetUserSessionsChatSessionsGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    (resolvedOptions && "queryKey" in resolvedOptions
      ? toValue(resolvedOptions.queryKey)
      : undefined) ?? getUserSessionsChatSessionsGetQueryKey(params);

  const query = useQuery(
    {
      ...getUserSessionsChatSessionsGetQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as UseQueryOptions<
      GetUserSessionsChatSessionsGetQueryResponse,
      ResponseErrorConfig<GetUserSessionsChatSessionsGet422>,
      TData,
      GetUserSessionsChatSessionsGetQueryResponse,
      TQueryKey
    >,
    toValue(queryClient),
  ) as UseQueryReturnType<
    TData,
    ResponseErrorConfig<GetUserSessionsChatSessionsGet422>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
